module.exports = __webpack_public_path__ + "static/media/hidden.df03fe3f.svg";